var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0.642578C0.445 0.642578 0 1.13522 0 1.74964V9.49911C0 9.79272 0.105357 10.0743 0.292893 10.2819C0.48043 10.4895 0.734784 10.6062 1 10.6062H8C8.26522 10.6062 8.51957 10.4895 8.70711 10.2819C8.89464 10.0743 9 9.79272 9 9.49911V5.62438H8V9.49911H1V1.74964H4.5V0.642578H1ZM7.39 1.19611C7.305 1.19611 7.215 1.23486 7.15 1.30682L6.54 1.97659L7.79 3.36043L8.4 2.69065C8.53 2.54673 8.53 2.30318 8.4 2.16479L7.625 1.30682C7.56 1.23486 7.475 1.19611 7.39 1.19611ZM6.185 2.3696L2.5 6.45468V7.83851H3.75L7.435 3.75343L6.185 2.3696Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b549b7de.svg";
export { ForwardRef as ReactComponent };